import {
  decodeESPNAccessRequestEnvelope,
  decodeESPNAccessRequestListEnvelope,
  type ESPNAccessRequest,
  type ESPNAccessRequestDecision,
  type ESPNAccessRequestStatus,
} from "@/models/espnAccessRequest";
import { apiRequest } from "./functionsClient";

export const ESPN_ACCESS_DENY_REASON_MAX_LENGTH = 2_000;

export class ESPNAccessRequestInputError extends Error {
  readonly field: "requestID" | "denyReason";

  constructor(field: ESPNAccessRequestInputError["field"], message: string) {
    super(message);
    this.name = "ESPNAccessRequestInputError";
    this.field = field;
  }
}

export async function listAdminESPNAccessRequests(
  status?: ESPNAccessRequestStatus,
): Promise<ESPNAccessRequest[]> {
  const response = await apiRequest<unknown>("/admin/espn-access/requests/list", {
    method: "POST",
    body: status ? { status } : {},
  });
  return decodeESPNAccessRequestListEnvelope(response);
}

export async function decideAdminESPNAccessRequest(
  requestID: string,
  decision: ESPNAccessRequestDecision,
  denyReason?: string | null,
): Promise<ESPNAccessRequest> {
  const cleanedRequestID = requestID.trim();
  if (!cleanedRequestID) {
    throw new ESPNAccessRequestInputError("requestID", "requestID is required");
  }
  const cleanedReason = denyReason?.trim() || undefined;
  if (cleanedReason && cleanedReason.length > ESPN_ACCESS_DENY_REASON_MAX_LENGTH) {
    throw new ESPNAccessRequestInputError("denyReason", "denyReason is too long");
  }

  const response = await apiRequest<unknown>("/admin/espn-access/requests/decide", {
    method: "POST",
    body: {
      requestID: cleanedRequestID,
      decision,
      ...(decision === "deny" && cleanedReason ? { denyReason: cleanedReason } : {}),
    },
  });
  return decodeESPNAccessRequestEnvelope(response);
}
